<template>
  <div>
    <div style="margin-bottom: 20px;" class="search_box">
      <el-input v-model="query.keywords" class="inptw" style="width: 300px;" placeholder="请输入员工编号和名称" />
      <el-select v-model="query.onlyMe" placeholder="请选择" style="width: 300px;">
        <el-option
          v-for="item in accountarr"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-button type="primary" class="searchurl" icon="el-icon-search" @click="searchclick">搜索</el-button>
      <el-button type="info" icon="el-icon-refresh" @click="reset">重置</el-button>
    </div>
    <div v-if="selectedList.length" class="selected_box">
      <span class="selected_label">已选员工：</span>
      <el-tag
        v-for="item in selectedList"
        :key="item.employee_no"
        closable
        type="warning"
        style="margin-right: 10px; margin-bottom: 6px;"
        @close="removeSelected(item)"
      >{{ item.name }}</el-tag>
    </div>
    <el-table
      ref="staffTable"
      v-loading="loading"
      :data="tableData"
      border
      row-key="employee_no"
      style="width: 100%"
      @select="handleSelect"
      @select-all="handleSelectAll"
    >
      <el-table-column
        type="selection"
        width="55"
        align="center"
      />
      <el-table-column
        prop="name"
        label="员工姓名"
        align="center"
      />
      <el-table-column
        prop="employee_no"
        label="员工编号"
        align="center"
      />
      <el-table-column
        prop="corp_name"
        label="企业名称"
        align="center"
      />
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <div class="que_box">
      <el-button type="primary" size="mini" @click="confirm">确定</el-button>
    </div>
  </div>
</template>

<script>
import { corpUsersList } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      tableData: [],
      selectedList: [],
      lastConfirmed: [],
      initialized: false,
      query: {
        page: 1,
        page_size: 10,
        onlyMe: 2,
        keywords: null
      },
      total: null,
      loading: false,
      accountarr: [{
        value: 1,
        label: '查看组内员工'
      }, {
        value: 2,
        label: '我关联的员工'
      }]
    }
  },
  methods: {
    normalize(selected) {
      return Array.isArray(selected) ? selected.map(item => ({
        employee_no: item.employee_no,
        name: item.name
      })) : []
    },
    open(selected) {
      const incoming = this.normalize(selected)
      if (!this.initialized) {
        this.selectedList = incoming
        this.lastConfirmed = incoming.map(item => ({ ...item }))
        this.initialized = true
        this.list()
        return
      }
      const incomingNos = incoming.map(item => item.employee_no)
      const lastNos = this.lastConfirmed.map(item => item.employee_no)
      this.selectedList = this.selectedList.filter(item => {
        const removedOutside = lastNos.includes(item.employee_no) && !incomingNos.includes(item.employee_no)
        return !removedOutside
      })
      incoming.forEach(item => {
        if (!this.selectedList.some(row => row.employee_no === item.employee_no)) {
          this.selectedList.push(item)
        }
      })
      this.list()
    },
    resetState() {
      this.selectedList = []
      this.lastConfirmed = []
      this.$nextTick(() => {
        this.restoreSelection()
      })
    },
    async list() {
      this.loading = true
      try {
        const data = await corpUsersList(this.query)
        this.tableData = data.data.list
        this.total = data.data.total
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.restoreSelection()
          })
        })
      } finally {
        this.loading = false
      }
    },
    restoreSelection() {
      if (!this.$refs.staffTable) return
      this.tableData.forEach(row => {
        const checked = this.selectedList.some(item => item.employee_no === row.employee_no)
        this.$refs.staffTable.toggleRowSelection(row, checked)
      })
    },
    handleSelect(selection, row) {
      const checked = selection.some(item => item.employee_no === row.employee_no)
      if (checked) {
        if (!this.selectedList.some(item => item.employee_no === row.employee_no)) {
          this.selectedList.push({
            employee_no: row.employee_no,
            name: row.name
          })
        }
      } else {
        this.selectedList = this.selectedList.filter(item => item.employee_no !== row.employee_no)
      }
    },
    handleSelectAll(selection) {
      const currentIds = this.tableData.map(row => row.employee_no)
      if (selection.length) {
        selection.forEach(row => {
          if (!this.selectedList.some(item => item.employee_no === row.employee_no)) {
            this.selectedList.push({
              employee_no: row.employee_no,
              name: row.name
            })
          }
        })
      } else {
        this.selectedList = this.selectedList.filter(item => !currentIds.includes(item.employee_no))
      }
    },
    removeSelected(item) {
      this.selectedList = this.selectedList.filter(row => row.employee_no !== item.employee_no)
      const current = this.tableData.find(row => row.employee_no === item.employee_no)
      if (current && this.$refs.staffTable) {
        this.$refs.staffTable.toggleRowSelection(current, false)
      }
    },
    confirm() {
      if (!this.selectedList.length) {
        this.$message.error('请选择员工')
        return
      }
      this.lastConfirmed = this.selectedList.map(item => ({ ...item }))
      this.$emit('staffcallback', this.lastConfirmed.slice())
    },
    fetchPageSize(e) {
      this.query.page_size = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    reset() {
      this.query.page = 1
      this.query.onlyMe = 2
      this.query.keywords = null
      this.list()
    }
  }
}
</script>
<style scoped>
.searchurl{
  margin-left: 10px;
}
.selected_box{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 12px;
}
.selected_label{
  margin-right: 8px;
  margin-bottom: 6px;
  color: #606266;
}
.que_box{
  margin-top: 16px;
  text-align: right;
}
</style>
